export default {
  'ArtistVideoSection.title': { en: 'Videos', fr: 'Vidéos' },
  'ArtistVideoSection.editVideos': {
    en: 'Edit Videos',
    fr: 'Modifier les vidéos',
  },
};
